module.exports = __webpack_public_path__ + "img/imp3.6de6a1c9.png";